import { format, differenceInMinutes, set as setDate } from 'date-fns';

export const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
};

export const dateFormatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
};

export const timeFormatOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
};

export function isDateSameOrBefore(date1: Date, date2: Date): boolean {
    return date1 <= date2;
}

export function isDateTimeSameOrAfter(date1: Date, date2: Date): boolean {
    return date1 >= date2;
}

export function createDateFromUTCString(utcDateString: string): Date {
    let convertedDate;

    if (utcDateString.slice(-1) !== 'Z') {
        convertedDate = new Date(`${utcDateString}Z`);
    } else {
        convertedDate = new Date(utcDateString);
    }

    return convertedDate;
}

export function getStartOfDay(date: Date): Date {
    const updateOptions = {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    };

    return setDate(date, updateOptions);
}

export function getEndOfDay(date: Date): Date {
    const updateOptions = {
        date: date.getDate() + 1,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    };

    return setDate(date, updateOptions);
}

export function dateWithDifferentYMD(date: Date, date2: Date): Date {
    const updateOptions = {
        year: date2.getFullYear(),
        month: date2.getMonth(),
        date: date2.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
    };

    return setDate(date, updateOptions);
}

export function newDateWithAddedDays(date: Date, days: number): Date {
    const updateOptions = {
        date: date.getDate() + days,
    };
    return setDate(date, updateOptions);
}

export function getDefaultStartDate(date: Date): Date {
    const updateOptions = {
        hours: 7,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    };

    return setDate(date, updateOptions);
}

export function getDefaultEndDate(date: Date): Date {
    const updateOptions = {
        hours: 23,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    };

    return setDate(date, updateOptions);
}

export function formatToNormalDate(date: Date): string {
    return format(date, 'yyyy.MM.dd HH:mm');
}

export function formatToTime(date: Date): string {
    return format(date, 'HH:mm');
}

function zeroPad(num: number, places: number): string {
    return String(num).padStart(places, '0');
}

export function differenceInTime(date1: Date, date2: Date): string {
    let minutes = differenceInMinutes(date1, date2);
    const hours = Math.floor(minutes / 60);
    minutes %= 60;
    return `${zeroPad(hours, 2)}:${zeroPad(minutes, 2)}`;
}
